module.exports = __webpack_public_path__ + "img/ImpresaEdileBPParallaxSmartphone.562c7b5e.jpg";